import React from 'react';
import { string } from 'prop-types';
import Typography from '@material-ui/core/Typography';
import GoogleDriveIcon from 'resources/images/GoogleDriveIcon.png';
import styles from './styles/index.scss';

export default class InstructionCard extends React.Component {
  static propTypes = {
    headerText: string,
    contentText: string,
    img: string,
    referenceLink: string
  };

  render() {
    const { headerText, contentText, img, referenceLink } = this.props;

    return (
      <div className={styles.card}>
        <div className={styles.imageContainer}>
          <img src={img} className={styles.image} />
        </div>
        <div className={styles.cardContent}>
          <Typography variant="h6" gutterBottom>
            {headerText}
          </Typography>
          <Typography variant="body1" color="textSecondary" gutterBottom>
            {contentText}
          </Typography>
          {referenceLink &&
            <Typography variant="body1" gutterBottom align="right">
              <a
                href={referenceLink}
                target="blank"
                className={styles.linkGdrive}
              >
                <img
                  src={GoogleDriveIcon}
                  width={18}
                  height={18}
                  className={styles.imgGdrive}
                />{' '}
                Reference doc
              </a>
            </Typography>}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/plugins/aiware/components/InstructionCard.js